const scrollTopBtn = document.querySelector('.productDetail__scroll-top');
if(scrollTopBtn){
scrollTopBtn.addEventListener('click', () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
});
}else{
  console.log('scrollTopBtn:',scrollTopBtn);
}

function displayRankNameAndRankIconAndGrantPoint(tags, publishedAt, price, targetEntry, loadingElm) {
  let unitPrice, grantPointPerUnit
  // 商品がセールかアウトレットの場合
  if (tags.includes("セール") || tags.includes("アウトレット")) {
    unitPrice = targetEntry.sale_outlet_point_per_unit;
    grantPointPerUnit = targetEntry.sale_outlet_reward_per_unit_points;
  }
  else {
    unitPrice = targetEntry.proper_point_per_unit;
    grantPointPerUnit = targetEntry.proper_reward_per_unit_points;
  }

  let taxPercentage;
  let publishedAtDate = new Date(publishedAt);  // 日付フォーマットで設定

  // publishedAtが2019年10月1日より前の場合
  // 2019年10月1日近辺のpublishedAtを持つ商品データはないということだったので、実行環境のタイムゾーンは考慮していない。
  if (publishedAtDate < new Date("2019-10-1")) {
    taxPercentage = 8;
  } else {
    taxPercentage = 10;
  };

  // 消費税抜き価格
  const priceExceptTax = price * 100 / (100 + taxPercentage);
  // 付与ポイント
  const grantPoint = Math.floor(priceExceptTax / unitPrice) * grantPointPerUnit;
  const formatGrantPoint = grantPoint.toLocaleString('ja-JP');
  // くるくるの非表示
  Array.from(loadingElm).forEach(elm => elm.style.display = "none");
  // 付与ポイント数表示
  document.querySelectorAll(".productDetail__point-number").forEach(function (element) {
    element.innerHTML = formatGrantPoint;
  });
}